import React, { useEffect, useState } from 'react';
import './Emails.scss';
import Layout from '../../../components/Admin/Layout';
import Subtitle from '../../../components/Admin/Subtitle';
import SearchButton from '../../../components/Admin/SearchButton';
import InputField from '../../../components/shared/InputField';
import RadioOption from '../../../components/Admin/RadioOption';
import Loading from '../../../components/shared/Loading'
import AdminService from '../../../services/AdminServices';
import MessageModal from '../../../components/shared/MessageModal';
import SearchWarning from '../../../components/Admin/SearchWarning'


const Emails = () => {

    const [loadingScreen, setLoadingScreen] = useState(false)
    const [orderNumber, setOrderNumber] = useState('');
    const [originType, setOriginType] = useState('');
    const [email, setEmail] = useState('');
    const [sendResendEmail, setSendResendEmail] = useState(0);
    const [messageSuccess, setMessageSuccess] = useState('')
    const [textLoading, setTextLoading] = useState(false)
    const sendEmail = async () => {

        console.log(originType, email);
        setTextLoading(true)
        try {
            const resendEmail = await AdminService.resendEmail(originType, orderNumber, email)
            // if (resendEmail) {
            //     setTextLoading(false)
            // }
            console.log(resendEmail)
            console.log(resendEmail.response)
            const { success, message } = resendEmail;
            if (message) {

            }
            setMessageSuccess(message + 'Valida el pedido en Big Ticket.');
            console.log(success);
            setSendResendEmail(success ? 1 : 2);
        } catch (e) {
            console.log("error", e);

            if (e.message == "Cannot read property 'data' of undefined") {

                setSendResendEmail(1);

            } else {
                setMessageSuccess('Intentelo Nuevamente');
                setSendResendEmail(2)
            }
        } finally {
            setTextLoading(false)
        }

        // if(response){
        //     setResendEmail(false)
        // }                

    }



    return (
        <>
            <Layout>
                <Loading visible={loadingScreen} />

                <div className="email-container gap-10">
                    <Subtitle
                        text='Reenvio de correos'
                    //   onClick={() => { setModalForm(true) }}
                    />
                    <div className="email-subcontainer-body">
                        <div className="col gap-10">
                            <h3> Origen del pedido</h3>
                            <div className="row gap-10" >
                                <RadioOption
                                    label='Productos Ripley'
                                    isChecked={originType === 'ripley'}
                                    // onClick={() => {
                                    // setRows([])
                                    // setOriginOption('mkp')
                                    // }}
                                    onClick={() => {
                                        setOriginType('ripley')
                                    }}
                                />
                                <RadioOption
                                    label='Marketplace'
                                    isChecked={originType === 'mkp'}
                                    onClick={() => {
                                        setOriginType('mkp')
                                    }}
                                />
                            </div>
                        </div>
                        {(originType) &&
                            <div className="col gap-10">
                                <h3>  Datos del reenvío </h3>
                                <form className="row gap-10">
                                    <InputField
                                        name=''
                                        label='N° Pedido'
                                        handleChange={value => setOrderNumber(value.target.value)}

                                    />
                                    <InputField
                                        name=''
                                        label='Email del cliente'
                                        handleChange={value => setEmail(value.target.value)}
                                    />
                                </form>
                            </div>
                        }
                        <div className="row ">
                            <div className="container-button-loading">
                                <SearchButton
                                    text={textLoading ? 'REENVIANDO' : 'REENVIAR CORREO'}
                                    onClick={sendEmail}
                                    loading={textLoading}
                                    disabled={textLoading || (!originType || !orderNumber || !email) || sendResendEmail === 1 || sendResendEmail === 2}
                                // disabled={resendEmail}
                                />

                            </div>

                        </div>
                    </div>
                    {
                        (sendResendEmail != 0) &&
                        ((sendResendEmail == 1) ? <MessageModal visible={sendResendEmail}
                            type={11}
                            txtBtn2='ENTENDIDO'
                            onClickBtn2={() => {
                                setSendResendEmail(0)
                                // setEmail('');
                                // setOrderNumber('');
                                // setOriginType('');
                            }}
                            title={messageSuccess}
                        >
                            <div className='annulment-modal'>
                                <p> Se reenvió el correo “Listo para Retirar” al email </p>
                                <strong> {email}</strong>
                                <p> del pedido Nº {orderNumber}</p>
                            </div>
                        </MessageModal> : <SearchWarning
                            title='Pedido no encontrado'
                            description={messageSuccess}
                            onClose={() => {
                                console.log('click on close');
                                setSendResendEmail(0)
                                // setEmail('');
                                // setOrderNumber('');
                                // setOriginType('');
                            }}
                        />)
                    }
                </div>
            </Layout>
        </>
    )
}

export default Emails;